/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import PageType from 'linced-app/enums/page-type';

export default class QuickCommentsRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      group: this.modelFor('group'),
      pages: this.store
        .query('posts/page', { type: PageType.STUDENT, visibleInMenu: true })
        .then((pages) => {
          return pages.filter((page) => page.hasPosts);
        }),
    });
  }
}
